import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// $FlowFixMe
import { useState } from 'react';
import ExpansionPanel from 'app/components/ExpansionPanel/ExpansionPanel';
import { Input } from 'app/components/Form';
import FlagsComponent from './FlagsComponent';
import classes from './Flags.module.scss';
import { cleanFlags } from 'app/store/reducers/reduxFlags';
import { useDispatch } from 'react-redux';
export const categoriesWithoutAssets = [
    {
        title: 'Articles',
        category: 'article',
    },
    {
        title: 'Takes',
        category: 'take',
    },
    {
        title: 'Dynamic Approval Values',
        category: 'dynamicApprovalValue',
    },
];
export const categoriesAssets = [
    {
        title: 'Episodes',
        category: 'ep',
    },
    {
        title: 'Folders',
        category: 'fo',
    },
    {
        title: 'Models',
        category: 'mo',
    },
    {
        title: 'Projects',
        category: 'pj',
    },
    {
        title: 'Shots',
        category: 'sh',
    },
];
export function Flags() {
    const dispatch = useDispatch();
    const [searchInput, setSearchInput] = useState('');
    const handleOnChange = (e) => {
        const value = e.target.value;
        setSearchInput(value);
        if (!value) {
            dispatch(cleanFlags());
        }
    };
    return (_jsxs("div", { style: { height: '100%', overflowY: 'auto' }, children: [_jsx(Input, { dataCy: "input-search", placeholder: "Search a flag", value: searchInput, onChange: handleOnChange, adornmentIcon: "fas-search", styleContainer: { maxWidth: 300, height: 'auto', margin: '15px' } }), searchInput.length === 0 ? (_jsxs("div", { className: classes.flagPanel, children: [_jsx(ExpansionPanel, { dataCy: "assets", title: "Assets", children: _jsx("div", { style: { width: '100%' }, children: categoriesAssets.map((asset) => (_jsx(ExpansionPanel, { dataCy: asset.category, title: `${asset.title}`, children: _jsx(FlagsComponent, { category: asset.category }) }, asset.category))) }) }), categoriesWithoutAssets.map((asset) => (_jsx(ExpansionPanel, { dataCy: asset.category, title: `${asset.title}`, children: _jsx(FlagsComponent, { category: asset.category }) }, asset.category)))] })) : (_jsxs("div", { className: classes.flagPanel, children: [_jsx("h2", { style: { marginLeft: '5px' }, children: "Search Result" }), _jsx(FlagsComponent, { searchInput: searchInput })] }))] }));
}
